import logoDefault from "../assets/images/LP-teamsix/team-six-logo.png"
import banner02 from "../assets/images/LP-teamsix/banner2.jpg"
import banner03 from "../assets/images/LP-teamsix/banner3.jpg"
import banner04 from "../assets/images/LP-teamsix/banner4.png"
import mobileBanner02 from "../assets/images/LP-teamsix/mobileBanner2.jpg"
import mobileBanner03 from "../assets/images/LP-teamsix/mobileBanner3.jpg"
import mobileBanner04 from "../assets/images/LP-teamsix/mobileBanner4.png"

export const LogoImage = {
  light: logoDefault,
};

export const NavLinks = [
  {
    name: "Quem somos",
    url: "#quem-somos",
  },
  {
    name: "Matrículas",
    url: "#matriculas",
  },
  {
    name: "Fale Conosco",
    url: "#contato",
  },
];

export const NavInnerLinks = [
  {
    name: "Quem Somos",
    url: "/#quem-somos",
  },
  {
    name: "Matrículas",
    url: "/#matriculas",
  },
  {
    name: "Fale Conosco",
    url: "/#contato",
  },
];

export const EliteData = [
  {
    countNumber: 156,
    aprovados: 'aprovados',
    curso: 'EsPCEx'
  },
  {
    countNumber: 80,
    aprovados: 'aprovados',
    curso: 'AFA'
  },
  {
    countNumber: 90,
    aprovados: 'aprovados',
    curso: 'EFOMM'
  },
  {
    countNumber: 48,
    aprovados: 'aprovados',
    curso: 'ITA'
  },
];

export const SliderOneData = [
  {
    image: banner04,
    imageMobile: mobileBanner04,
    shape: 'shape01',
    title: "Turma Elite",
    subTitle: "Preparação premium para Medicina, com método estratégico e foco em ENEM e UFRGS",
    highlight: "\nMED",
    button: {
      label: "Seja Elite Med",
      url: "https://wa.me/5551991709380",
    },
    
  },
  {
    image: banner02,
    imageMobile: mobileBanner02,
    shape: 'shape01',
    subTitle: "Somos referência em aprovação nos principais concursos militares. Comece agora sua preparação!",
    title: "Seja a ",
    highlight: "elite\n militar",
    button: {
      label: "Seja Team Six",
      url: "https://wa.me/5551991709380",
    },
    
  },
  {
    image: banner03,
    imageMobile: mobileBanner03,
    shape: 'shape01',
    subTitle: "",
    title: "",
    highlight: "ESA, EsPCEx,\n AFA, EFOMM,\n EN, IME e ITA",
    button: {
      label: "Seja Team Six",
      url: "https://wa.me/5551991709380",
    },
    
  },
];
